import { PlugsConnected } from '@phosphor-icons/react'
import { COLOR_BLACK } from 'constant/colors'
import useSessionStore from 'Context/useSessionStore'
import QuickbooksLogo from 'Assets/images/quickbooks.svg'

const IntegrationElement = ({ logo, title, description, integrationInfo, onConnect, onEdit, onDelete }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))
  return (
        <div className="col-12 mb-4">
            <div className='card card-secondary px-5 py-4'>
            <div className='row justify-content-between'>
                <div className='col-4 col-md-1 px-0 pr-0 px-md-2' style={{ maxWidth: '60px' }}>
                    <img className='img-fluid w-100 rounded' alt="quickbooks" src={QuickbooksLogo}/>
                </div>
                <div className='col-12 col-md-7 p-0'>
                <h6>{title}</h6>
                <p className='m-0'>{description}</p>
                </div>
                <div className='col-12 col-md-auto px-0'>
                    <button
                        type="button"
                        className="btn btn-secondary text-no-wrap">
                        <PlugsConnected className="icon" size={15} color={COLOR_BLACK} weight="bold" />
                        <span className="ms-1">Connect</span>
                    </button>
                </div>
            </div>
            </div>
        </div>
  )
}

export default IntegrationElement
